import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import {
  useDropdown,
  UsecitiesDropdowns,
  useStatesDropdowns,
} from "../../actions/authActions";
import { SwalAlert } from "../../components/index";
import textWeight from "../../utils/textWeight";
export default () => {
  const { TextWeight } = textWeight();
  const [loadingJobStatusapi, setLoadingJobStatusapi] = useState(false);
  const [loadingJobStatusRejected, setLoadingJobStatusRejected] =
    useState(false);
  const [loadingJobStatusSaved, setLoadingJobStatusSaved] = useState(false);
  const queryClient = useQueryClient();
  const applicants = useSelector((state) => state.app.applicants.applicants);
  const userData = useSelector((state) => state.app.userData.userData);
  const [activeTab, setActiveTab] = useState("Pending");
  const [valuejobslisting, setValueJobslisting] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [filterPopup, setFilterPopup] = useState(false);
  const [savedJobs, setSavedJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      jobtitle: "",
      expirydate: "",
      postCode: "",
      salaryFrom: "",
      salaryTo: "",
      positions: "",
      description: "",
      job_shift: "",
    },
  });
  const [select, setSelect] = useState({
    countries: "",
    states: "",
    city: "",
    gender: "",
    ethinicity: "",
    hairTypes: "",
    eyeColors: "",
  });
  const handleDropdwonSelect = (name, value) => {
    setSelect((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const fetchjobsSavedJobs = async () => {
    const userId = localStorage.getItem("userId");
    const { data } = await axios.get(`${baseURL}/api/v2/saved-jobs`, {
      params: { user_id: userId },
    });
    return data?.data;
  };
  const { data: jobsSavedJobs } = useQuery({
    queryKey: ["jobsSavedJobs"],
    queryFn: fetchjobsSavedJobs,
  });

  useEffect(() => {
    if (jobsSavedJobs) {
      const savedJobIds = jobsSavedJobs?.job_applies.map((job) =>
        String(job?.job?.id)
      );
      setSavedJobs(savedJobIds);
    }
  }, [jobsSavedJobs]);

  const fetchAppliedJobData = async ({ queryKey }) => {
    const [, page, activeTab, filters] = queryKey;
    const params = {
      job_id: applicants,
      employer_id: userData?.employer?.id,
      status: activeTab,
      ...(filters || {}),
    };
    const accessToken = localStorage.getItem("accessToken");
    const { data } = await axios.get(
      `${baseURL}/api/v2/applied-jobs?page=${page}`,
      {
        params,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data?.data;
  };

  const {
    data: appliedJobData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["appliedJobData", 1, activeTab, filters],
    queryFn: fetchAppliedJobData,
    keepPreviousData: true,
  });
  useEffect(() => {
    if (!isLoading) {
      setFilterPopup(false);
    }
  }, [isLoading]);
  const { has_more_pages, total_pages } = appliedJobData || {};
  const { data: dropdowns, isLoading: dropdownLoading } = useDropdown();

  const { data: states, isLoading: isLoadingStates } = useStatesDropdowns(
    select.country
  );
  const { data: cities, isLoading: citiesisLoading } = UsecitiesDropdowns(
    select?.states
  );

  const [rangeHeight, setRangeHeight] = useState([null, null]);
  const [tooltipPosHeight, setTooltipPosHeight] = useState([0, 0]);
  const sliderRefHeight = useRef(null);

  const updateTooltipPosHeight = (value) => {
    const [minVal, maxVal] = value;
    const percentStart = ((minVal - 120) / (220 - 120)) * 100;
    const percentEnd = ((maxVal - 120) / (220 - 120)) * 100;
    setTooltipPosHeight([percentStart, percentEnd]);
  };

  const handleInputHeight = (value, userInteraction) => {
    setRangeHeight(value);
    if (userInteraction) updateTooltipPosHeight(value);
  };

  useEffect(() => {
    updateTooltipPosHeight(rangeHeight);
  }, [rangeHeight]);

  const [rangeWeight, setRangeWeight] = useState([null, null]);
  const sliderRefWeight = useRef(null);
  const [tooltipPosWeight, setTooltipPos] = useState([0, 0]);
  const updateTooltipPos = (value) => {
    const [minVal, maxVal] = value;
    const percentStart = ((minVal - 25) / (200 - 25)) * 100;
    const percentEnd = ((maxVal - 25) / (200 - 25)) * 100;
    setTooltipPos([percentStart, percentEnd]);
  };

  const handleInputWeight = (value, userInteraction) => {
    setRangeWeight(value);
    if (userInteraction) updateTooltipPos(value);
  };

  useEffect(() => {
    updateTooltipPos(rangeWeight); // Initial set
  }, [rangeWeight]);

  const [rangeAge, setRangeAge] = useState([null, null]);
  const [tooltipPosAge, setTooltipPosAge] = useState([0, 0]);
  const sliderRefAge = useRef(null);
  const updateTooltipPosAge = (value) => {
    const [minVal, maxVal] = value;
    const percentStart = ((minVal - 6) / (90 - 6)) * 100;
    const percentEnd = ((maxVal - 6) / (90 - 6)) * 100;
    setTooltipPosAge([percentStart, percentEnd]);
  };

  const handleInputAge = (value, userInteraction) => {
    setRangeAge(value);
    if (userInteraction) updateTooltipPosAge(value);
  };

  useEffect(() => {
    updateTooltipPosAge(rangeAge);
  }, [rangeAge]);

  const mutationJobStatus = useMutation({
    mutationFn: async (JobStatusData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/update-applyjob-status`,
        JobStatusData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      setLoadingJobStatusapi(false);
      setLoadingJobStatusRejected(false);
      setShowPopup(false);
      const title = data.status;
      const message = data.message;
      SwalAlert(title, message, "success");
      queryClient.invalidateQueries({
        queryKey: ["appliedJobData", 1, activeTab],
      });
    },
    onError: (error) => {
      setShowPopup(false);
      setLoadingJobStatusapi(false);
      setLoadingJobStatusRejected(false);
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
    },
  });
  const handleJobStatusUpdate = (talentId, status) => {
    setLoadingJobStatusapi(true);
    mutationJobStatus.mutate({
      job_id: applicants,
      talent_id: talentId,
      employer_id: userData?.employer?.id,
      status: status,
    });
  };
  const handleJobStatusRejectedUpdate = (talentId, status) => {
    setLoadingJobStatusRejected(true);
    mutationJobStatus.mutate({
      job_id: applicants,
      talent_id: talentId,
      employer_id: userData?.employer?.id,
      status: status,
    });
  };
  const handleJobStatusSavedUpdate = (talentId, status) => {
    setLoadingJobStatusSaved(true);
    mutationJobStatus.mutate({
      job_id: applicants,
      talent_id: talentId,
      employer_id: userData?.employer?.id,
      status: status,
    });
  };
  const startChatMutation = useMutation({
    mutationFn: async (startChat) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/chat/start`,
        startChat,
        {
          params: {
            sender_id: startChat?.sender_id,
            receiver_id: startChat?.receiver_id,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      dispatch({
        type: "UPDATE_USER_CHAT_DATA",
        payload: { userChatData: data?.chat_head },
      });
      navigate(`/chat/${data?.chat_head?.id}`);
      setLoading(false);
    },
    onError: (err) => {
      setLoading(false);
      SwalAlert("Oops...", err?.message, "error");
    },
  });
  const handleStartChat = (receiver_id, sender_id) => {
    setLoading(true);
    startChatMutation.mutate({ receiver_id, sender_id });
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  const onSubmit = (data, e) => {
    e.preventDefault();
    const newFilters = {};
    if (select.country) newFilters["country_id[]"] = select.country;
    if (select?.states) newFilters["state_id[]"] = select?.states;
    if (select.city) newFilters["city_id[]"] = select.city;
    if (select.gender) newFilters["gender[]"] = select.gender;
    if (select.ethinicity) newFilters["ethinicity_id[]"] = select.ethinicity;
    if (select.hairTypes) newFilters["hair_type[]"] = select.hairTypes;
    if (select.eyeColors) newFilters["eye_colors[]"] = select.eyeColors;
    if (rangeAge[0] != null && rangeAge[1] != null) {
      newFilters["age[]"] = rangeAge;
    }
    if (rangeHeight[0] != null && rangeHeight[1] != null) {
      newFilters["height[]"] = rangeHeight;
    }
    if (rangeWeight[0] != null && rangeWeight[1] != null) {
      newFilters["weight[]"] = rangeWeight;
    }
    if (data.bodyTattoos !== undefined && data.bodyTattoos !== "") {
      newFilters["tattoos[]"] = data.bodyTattoos;
    }

    if (data.bodyPiercings !== undefined && data.bodyPiercings !== "") {
      newFilters["piercings[]"] = data.bodyPiercings;
    }

    if (select.experienceLevel)
      newFilters["experience_level[]"] = select.experienceLevel;
    setFilters(newFilters); // This triggers the useQuery refetch
  };
  const resetFilters = () => {
    setFilters({});
    setSelect("");
    reset();
    setRangeWeight([null, null]);
    setRangeHeight([null, null]);
    setRangeAge([null, null]);
  };
  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "long", day: "2-digit" };
    return date.toLocaleDateString("en-GB", options);
  };

  const RadioValueandLable = [
    { id: 1, title: "Yes" },
    { id: 0, title: "No" },
  ];
  return {
    loadingJobStatusapi,
    loadingJobStatusRejected,
    loadingJobStatusSaved,
    isLoading,
    appliedJobData,
    has_more_pages,
    total_pages,
    setCurrentPage,
    currentPage,
    activeTab,
    setActiveTab,
    setShowPopup,
    showPopup,
    filterPopup,
    setFilterPopup,
    dropdowns,
    dropdownLoading,
    register,
    handleSubmit,
    control,
    errors,
    handleDropdwonSelect,
    select,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    rangeHeight,
    tooltipPosHeight,
    sliderRefHeight,
    handleInputHeight,
    rangeWeight,
    tooltipPosWeight,
    sliderRefWeight,
    handleInputWeight,
    rangeAge,
    tooltipPosAge,
    sliderRefAge,
    handleInputAge,
    onSubmit,
    resetFilters,
    formatDate,
    RadioValueandLable,
    handleStartChat,
    userData,
    savedJobs,
    handleJobStatusUpdate,
    handleJobStatusRejectedUpdate,
    handleJobStatusSavedUpdate,
    baseURL,
    mutationJobStatus,
    loading,
    setValueJobslisting,
    valuejobslisting,
    TextWeight,
  };
};
